class WCReleatedProducts extends HTMLElement {
  constructor() {
    super();
    this.useSearchAndDiscovery = this.getAttribute('use-search-and-discovery') === 'true';
    this.fetchURL = this.getAttribute('fetch-url');
    this.sourceProductID = this.getAttribute('source-product-id');
    this.sectionID = this.getAttribute('section-id');
  }

  connectedCallback() {
    if (
      this.useSearchAndDiscovery &&
      this.fetchURL &&
      this.sourceProductID &&
      this.sectionID
     ) {
      this.initializeRecommendations(this.sourceProductID);
    }
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      async (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        await this.loadRecommendations(productId);
      },
      { rootMargin: '400px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  async loadRecommendations(productId) {
    try {
      const response = await fetch(`${this.fetchURL}&product_id=${productId}&section_id=${this.sectionID}`);
      const text = await response.text();
      const html = document.createElement('div');
      html.innerHTML = text;
      const recommendations = html.querySelector('[data-wc-related-products]');

      if (recommendations?.innerHTML.trim().length) {
        this.innerHTML = recommendations.innerHTML;
        yotpoWidgetsContainer.initWidgets();
      }
    } catch (e) {
      console.error(e);
    }
  }
}

if (typeof customElements.get('wc-related-products') === 'undefined') {
  customElements.define('wc-related-products', WCReleatedProducts);
}
